import React from 'react';
import { ArrowRight } from 'lucide-react';
import { BrandButton } from './ui-kit/BrandButton';
import { Reveal } from './ui-kit/Reveal';

/**
 * Mid-page CTA — calmer than the final dark CTA block, but clear.
 * Used inside Meistä and UKK pages to give visitors a helpful next step.
 */
export const MidCTA = ({
  title = 'Haluatko nähdä, miten tämä toimisi sinulla?',
  subtitle = 'Aloitetaan 20 minuutin maksuttomalla kartoituksella. Saat arvion sopivasta käyttötapauksesta, toteutuksesta ja seuraavista askelista.',
  buttonLabel = 'Varaa maksuton kartoitus',
  to = '/yhteys#contact-form',
}) => {
  return (
    <section className="py-12 md:py-16" data-testid="mid-cta">
      <div className="container-page">
        <Reveal>
          <div className="rounded-card bg-brand-soft border border-brand/20 p-7 md:p-9 grid md:grid-cols-12 gap-6 items-center">
            <div className="md:col-span-8">
              <h2 className="text-h3 text-ink">{title}</h2>
              <p className="mt-2 text-body text-ink-muted max-w-xl">{subtitle}</p>
            </div>
            <div className="md:col-span-4 md:flex md:justify-end">
              <BrandButton to={to} variant="primary" iconRight={ArrowRight} data-testid="mid-cta-button">
                {buttonLabel}
              </BrandButton>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
};

export default MidCTA;
